// extracted by mini-css-extract-plugin
export var contentWrapper = "MemberJourney-module--contentWrapper--V9Ife";
export var headerSection = "MemberJourney-module--headerSection--5ENa+";
export var icon = "MemberJourney-module--icon--LNqrd";
export var iconWrapper = "MemberJourney-module--iconWrapper--EK-cb";
export var itemDescription = "MemberJourney-module--itemDescription--bAjyd";
export var itemTitle = "MemberJourney-module--itemTitle--hgGla";
export var journeyColumn = "MemberJourney-module--journeyColumn--brV1H";
export var journeyItem = "MemberJourney-module--journeyItem--I1cvL";
export var mainTitle = "MemberJourney-module--mainTitle--bPiWO";
export var memberJourneyWrapper = "MemberJourney-module--memberJourneyWrapper--giNAP";